module.exports = __webpack_public_path__ + "img/sipshark_logo.eea4507e.svg";